/**
 * status 当前订单的状态的下一个状态，在父组件，可通过 import orderflowHelper from '@/config/order'，然后orderflowHelper.getNextOrderStatus('flow1', '当前订单状态', true)得到下一个订单状态
 */
<template>
  <!-- 正常状态的显示；代办状态的显示 -->
  <div class="order-status-form clearfix">
    <template v-if="orderStatustType==='normal'">
      <!-- <div class="title" v-text="title"></div> -->
      <template v-if="showForm && status">
        <component @getIsReviewOK='getIsReviewOK' v-if="hasForm" :is="status" ref="orderStatusForm" v-bind="$attrs" :status="status" :order="order" :detailIn="true" :orderStatus="orderStatus" @updateLoading="updateLoading" @on-error="onError" @on-success="onSuccess" @add-abnormalReason="addAbnormalReason"></component>
        <el-button size="small" @click="next" type="primary" class="next btn" :class="statusColor" :disabled='isReviewExcelOK'>{{submitText}}</el-button>
      </template>

      <!-- 检测中： -->
      <el-button size="small" v-if="status==='ORDER_EXAM'" @click="testAgain" type="danger" plain class="next btn">复测</el-button>

      <!-- 待报告： -->
      <template v-if="status=== 'REPORT_CREATE'">
        <el-button size="small" @click="receivedData" type="primary" class="next btn" :disabled="isReceiveExamData">确认已接收数据</el-button>
        <el-button size="small" @click="generateReport" type="primary" class="next btn"  :disabled="!isReceiveExamData">确认已编制报告</el-button>
      </template>
      <!-- 待归还： -->
      <template v-if="status=== 'ORDER_BACK'">
        <el-button size="small" @click="revertData" type="primary" class="next btn" :disabled="isOrderBack">确认已归还</el-button>
        <el-button size="small" @click="recoveryData" type="primary" class="next btn" :disabled="!isOrderBack">确认已回收</el-button>
      </template>

      <slot></slot>
    </template>
    <template v-else-if="orderStatustType==='pending'">
      <task-operate :task="task" @on-success="onSuccess" @before-submit="updateLoading" @on-error="onError" :orderDetail="orderDetail"></task-operate>
    </template>
    <!-- 复测弹窗 -->
    <test-again-dialog :dialogVisible="showDialog" @close="closeDialog" @submit="testAgainSubmit">
    </test-again-dialog>
  </div>
</template>
<script>
import ORDER_RECEIVED from './form/ORDER_RECEIVED'
import ORDER_EXAM from './form/ORDER_EXAM'
import DATA_RETURN from './form/DATA_RETURN'
// import REPORT_CHECKED from './form/REPORT_CHECKED'
import SAMPLE_RETURNED from './form/SAMPLE_RETURNED'
import taskOperate from './form/components/task-operate'
import ORDER_ASSIGN from './form/ORDER_ASSIGN.vue'
import ORDER_GET from './form/ORDER_GET'
import {
  next } from './status.js'
import testAgainDialog from './test-again-dialog.vue'

export default {
  name: 'order-status',
  props: {
    task: {
      type: Object
    },
    status: {
      type: String,
      required: true,
      default: ''
    },
    // 是否是任务状态流
    isTask: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      required: true
    },
    orderStatus: [Array],
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    ORDER_ASSIGN,
    ORDER_RECEIVED,
    // REPORT_CHECKED,
    ORDER_EXAM,
    DATA_RETURN,
    taskOperate,
    SAMPLE_RETURNED,
    ORDER_GET,
    testAgainDialog
    // orderHandleDialog
    // MUTATION_VERIFICATION,
    // SAMPLE_RECOLLECT
  },
  data () {
    return {
      title: '',
      creatNum: 0,
      isReviewOK: true,
      showDialog: false,
      testAgainForm: {}
    }
  },
  computed: {
    isReceiveExamData () {
      return this.order.isReceiveExamData
    },
    isOrderBack () {
      return this.order.isOrderBack
    },
    showForm () {
      const noForm = [ 'REPORT_CREATE', 'ORDER_BACK']
      return !this.task && !noForm.includes(this.status)
    },
    submitText () {
      let res = '提交'
      switch (this.status) {
        case 'ORDER_GET':
          res = '确认已领样'
          break
        case 'ORDER_EXAM':
          res = '确认已提交原始记录'
          break
        case 'REPORT_CREATE':
          res = '确认已接收数据'
          break
        case 'REPORT_CHECKED':
          res = '确认已审核报告'
          break
      }
      return res
    },
    hasForm () {
      const noForm = ['ORDER_GET', 'ORDER_EXAM', 'REPORT_CREATE', 'REPORT_CHECKED']
      return !noForm.includes(this.status)
    },
    isReviewExcelOK () {
      if (this.order.nextOrderAction === 'LAB_DNA_READY' || this.order.nextOrderAction === 'AMPLIFICATION' || this.order.nextOrderAction === 'REPORT_CREATE') {
        return !this.isReviewOK
      } else {
        return false
      }
    },
    isAfterQualityOperation () {
      // 是否是单独排版
      return this.order.afterQualityOperation === 'SUPPLEMENT_OTHER_SAMPLE_BOARD'
    },
    isBandButton () {
      return !!(this.order.currentSample.chipIds && this.order.currentSample.chipIds.length)
    },
    orderStatustType () {
      let type = 'normal'
      if (this.task) {
        type = 'pending'
      }
      return type
    },
    // 突变报告结果数据
    detectionResultData () {
      let res = null
      if (this.task) {
        let mutationVerifyInformation = this.task.orderActionData.statusDetail ? this.task.orderActionData.statusDetail.mutationVerifyInformation : null
        if (mutationVerifyInformation) {
          res = []
          mutationVerifyInformation.forEach(item => {
            let { geneType, autoCausalAnalysisResults } = item
            autoCausalAnalysisResults.forEach(item => {
              let { autoCausalLociParam } = item
              res.push({
                geneType,
                ...autoCausalLociParam
              })
            })
          })
        }
      }
      return res
    },
    statusColor () {
      if (this.creatNum === 1) {
        return 'orange'
      } else if (this.creatNum > 1) {
        return 'red'
      }
      return ''
    }
  },
  mounted () {
    this.$refs.orderStatusForm && (this.title = this.$refs.orderStatusForm.title)
  },
  methods: {
    testAgain () {
      this.showDialog = true
    },
    generateReport () {
      let data = {
        orderStatusResult: 'REPORT_CREATED'
      }
      this.noFormSubmit(data)
    },
    receivedData () {
      let data = {
        orderStatusResult: 'RECEIVE_EXAM_DATA'
      }
      this.noFormSubmit(data)
    },
    revertData () {
      let data = {
        orderStatusResult: 'CONFIRM_ORDER_BACK'
      }
      this.noFormSubmit(data)
    },
    recoveryData () {
      let data = {
        orderStatusResult: 'CONFIRM_ORDER_RECOVERY'
      }
      this.noFormSubmit(data)
    },
    closeDialog () {
      this.showDialog = false
    },
    getIsReviewOK (val) {
      this.isReviewOK = val
    },
    addAbnormalReason (param) {
      let data = param.options.find(item => {
        return item.id === param.value
      })
      if (!data) {
        let data = {
          name: param.value,
          value: param.value,
          type: param.type
        }
        return this.$store.dispatch('addAbnormalReason', data)
      }
    },
    btnColor () {
      for (let status of this.orderStatus) {
        if (status.orderStatus === 'LAB_SAMPLE_RETURNED') {
          this.creatNum = this.creatNum + 1
        }
      }
    },
    testAgainSubmit (form) {
      this.testAgainForm = form
      let dataCurrent = {
        billId: this.order.billId,
        action: this.status,
        orderStatusDetail: {
          action: this.status,
          ...this.testAgainForm,
          orderStatusResult: 'RETEST'
        }
      }
      if (this.isTask) {
        dataCurrent.taskId = this.order.id
        dataCurrent.productionTaskTrigger = true
      } else {
        dataCurrent.orderIds = [this.order.id]
      }
      next.call(this, dataCurrent).then(res => {
        this.$emit('isLoading', false)
        this.$emit('status-change')
      }).catch(err => {
        this.$emit('isLoading', false)
        this.$message.error(err.message || err)
      })
      this.showDialog = false
    },
    next (data) {
      if (!this.hasForm) {
        this.noFormSubmit()
        return
      }
      let formValidata = this.$refs.orderStatusForm && this.$refs.orderStatusForm.formValidata
      if (formValidata) {
        formValidata().then(response => {
          this.doNext(data)
        }).catch(err => {
          console.warn(err)
        })
      } else {
        this.doNext()
      }
    },
    noFormSubmit (data) {
      this.$emit('isLoading', true)
      if (this.status === 'ORDER_EXAM') {
        // if (this.testAgainForm.reason) {
        //   this.testAgainForm.orderStatusResult = 'RETEST'
        // } else {
        //   this.testAgainForm.orderStatusResult = 'CONFIRM_EXAM_DATA'
        // }
        this.testAgainForm.orderStatusResult = 'CONFIRM_EXAM_DATA'
      }

      let dataCurrent = {
        billId: this.order.billId,
        action: this.status,
        orderStatusDetail: {
          action: this.status,
          ...this.testAgainForm,
          ...data
        }
      }
      if (this.isTask) {
        dataCurrent.taskId = this.order.id
        dataCurrent.productionTaskTrigger = true
      } else {
        dataCurrent.orderIds = [this.order.id]
      }
      next.call(this, dataCurrent).then(res => {
        this.$emit('isLoading', false)
        this.$emit('status-change')
      }).catch(err => {
        this.$emit('isLoading', false)
        this.$message.error(err.message || err)
      })
    },
    doNext (data) {
      this.$emit('isLoading', true)
      this.$refs.orderStatusForm.next(data).then(response => {
        this.$emit('isLoading', false)
        this.$emit('status-change')
      }).catch(err => {
        this.$emit('isLoading', false)
        this.$message.error(err.message || err)
      })
    },
    updateLoading (val) {
      this.$emit('isLoading', true)
    },
    onSuccess (data = {}) {
      let { isDELETE } = data
      if (isDELETE) {
        history.go(-1)
        return
      }
      this.$emit('status-change')
    },
    onError () {
      this.$emit('isLoading', false)
    }
  },
  watch: {
    orderStatus (val) {
      this.creatNum = 0
      this.btnColor()
    }
  },
  created () {
    this.btnColor()
  }
}
</script>
<style lang="less">
.order-status-form {
  padding: 40px 20px;
  .el-button.next {
    margin-top: 30px;
  }
  el-textarea,
  .el-textarea__inner,
  .el-input__inner {
    width: 500px;
    font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
  }
  .el-upload-list {
    max-width: 800px;
  }
}
</style>
<style module lang="less">
.table {
  margin-bottom: 20px;
  &__title {
    font-weight: bold;
    padding: 20px 0;
  }
}
.upload {
  margin-top: 20px;
}
</style>
